import ReactDOM from 'react-dom/client';
import { AppDispatch } from '../index';
import { AppBridgeEvent } from '../model/appBridge';
import { initStaticCodebooks } from '../store/codebooks';
import { getLocale, setLocale } from './i18n';

const renderRoots: { [hash: string]: { root: ReactDOM.Root; mountId?: number } } = {};

export function getPageHash(event: AppBridgeEvent) {
  return `${event.page}-${event.rootId}` + (event.instanceId ? '-' + event.instanceId : '');
}

/** Whether an event is about the given mount; an id missing on either side (older shell) matches */
export function isSameMount(event: AppBridgeEvent, mountId?: number) {
  return event.mountId === undefined || mountId === undefined || event.mountId === mountId;
}

export function unmountBridgedPage(event: AppBridgeEvent) {
  const hash = getPageHash(event);
  const mounted = renderRoots[hash];
  // re-entering a state mounts the new page before the old scope is destroyed,
  // so a late destroy must not take the fresh root down with it
  if (!mounted || !isSameMount(event, mounted.mountId)) {
    return;
  }
  mounted.root.unmount();
  delete renderRoots[hash];
}

export function createBridgedPage(event: AppBridgeEvent, rootElm: HTMLElement) {
  const hash = getPageHash(event);
  // a root under the same hash would otherwise leak (stay mounted, keep window listeners)
  renderRoots[hash]?.root.unmount();
  const root = ReactDOM.createRoot(rootElm);
  renderRoots[hash] = { root, mountId: event.mountId };
  return root;
}

export function appBridgeCheckContext(event: AppBridgeEvent, dispatch: AppDispatch) {
  if ('context' in event && event?.context?.lang && event?.context?.lang !== getLocale()) {
    setLocale(event?.context?.lang);
    dispatch(initStaticCodebooks());
  }
}
